export default "__VITE_ASSET__bWp4OMEF__"